const styles = {
  infoPanel: {
    paddingTop: "80px",
    position: "absolute",
    width: "284px",
    right: "0%",
    height: "100%",
    display: "inline-block",
    backgroundColor: "#000000",
    zIndex: 900,
  },
  info: {
    cursor: "pointer",
    position: "absolute",
    right: "3%",
    top: "7%",
    zIndex: 1000,
    "@media screen and (max-width : 1200px)": { display: "none" },
  },

  instagram: {
    display: "inline-block",
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 300,
    fontFamily: ({ theme }) => theme.fontFamily,
    position: "relative",
    left: "15px",
  },
  instagramTitle: {
    position: "relative",
    bottom: "7px",
    left: "10px",
  },

  instagramDescription: {
    marginTop: "10px",
    width: "90%",
  },

  description: {
    padding: "0 15px",
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 300,
    lineHeight: "22px",
    height: "80%",
    overflowY: "auto",
    left: "24px",
    fontFamily: ({ theme }) => theme.fontFamily,
    wordBreak: "break-word",
  },

  viewer: {
    width: "100%",
    height: " calc(100% - 175px)",
    display: "flex",
    overflow: "hidden",
    justifyContent: "center",
    position: "relative",
    background: "#000000",
  },

  imgContainer: {
    height: "100%",
    position: "relative",
    display: "inline-block",
    "@media screen and (max-width : 1200px)": {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "@media screen and (max-width : 767px) and (orientation: landscape)": {
      height: "100%",
      width: "50%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
    },
  },

  img: {
    width: "auto",
    height: "100%",
  },
  imgText: {
    position: "absolute",
    bottom: "5%",
    left: "24px",
    width: "540px",
    color: "#FFFFFF",
    fontFamily: '"CircularStd"',
    fontSize: "36px",
    fontWeight: "500",
    lineHeight: "46px",
    zIndex: "10",
    textShadow: "2px 2px 2px rgba(0,0,0,0.5)",
  },
  imgTitle: {
    "@media screen and (max-width : 1200px)": {
      position: "absolute",
      bottom: "5%",
      left: "24px",
      height: "25px",
      color: "#051D39",
      fontFamily: '"CircularStd"',
      fontSize: "20px",
      fontWeight: "500",
      letterSpacing: "0",
      lineHeight: "25px",
    },
  },
};
export default styles;
